<!--<div class="container-fluid">-->

  <form id="self-information" [formGroup]="regForm" (ngSubmit)="step7Submitted(regForm)" novalidate>


      
    <div class="form-row">
      <label style="font-weight: bold; font-size: x-large;">{{'Step7-Availability.TranslationSection.text1' | translate}}</label>
    
    </div><br><br>
    



<div>
    

  <div class="form-group col-lg-12 col-sm-12 col-md-12" >

    <label>{{'Step7-Availability.TranslationSection.text2' | translate}}
    </label>

    <div class="form-row">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox"  id="Availfull" formControlName="Availfull" value="Full Time" >
        <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text3' | translate}}</label>
    </div>
    <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox"  id="Availpart" formControlName="Availpart" value="Part Time" >
        <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text4' | translate}}</label>
    </div> 
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox"  id="Availwkend" formControlName="Availwkend" value="Weekends" >
      <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text5' | translate}}</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="Availdays" formControlName="Availdays" value="Days" >
    <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text6' | translate}}</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="Availeve" formControlName="Availeve" value="Nights" >
    <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text7' | translate}}</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="Availvisits" formControlName="Availvisits" value="Live-In" >
    <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text8' | translate}}</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="Availdiem" formControlName="Availdiem" value="Per Diem" >
    <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text9' | translate}}</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="Availother" formControlName="Availother" (change)="availClick($event)" value="Other" >
    <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text10' | translate}}</label>
  </div>      
    </div>

    
    <div class="form-row" style="height:50px;"></div>

    <div class="form-row">
      <div class="form-group col-lg-3 col-sm-3 col-md-3" >
        <label>{{'Step7-Availability.TranslationSection.text11' | translate}}</label>
  
      </div>
      <div class="form-group  col-lg-4 col-sm-4 col-md-4" >
  
        <div class="form-check form-check-inline">
            <textarea class="form-control"  id="Avail" for="Avail" formControlName="Avail" ></textarea>
        
        </div>
        
      </div>
  </div>




  <div class="form-row">
    <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
      <label>{{'Step7-Availability.TranslationSection.text12' | translate}}</label>

    </div>
    <div class="form-group  col-lg-4 col-sm-4 col-md-4" >

      <div class="form-check form-check-inline">
          <textarea class="form-control"  id="Language" for="Language" formControlName="Language" ></textarea>
      
      </div>
      
    </div>
</div>

<!--
<div class="form-row">
  <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
    <label>Other Professional Memberships:</label>

  </div>
  <div class="form-group  col-lg-4 col-sm-4 col-md-4" >

    <div class="form-check form-check-inline">
        <textarea class="form-control"  id="Memberships" for="Memberships" formControlName="Memberships" ></textarea>
    
    </div>
    
  </div>
</div>
-->



<div class="form-row">
  <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
    <label>{{'Step7-Availability.TranslationSection.text13' | translate}}</label>

  </div>
  <div class="form-group  col-lg-5 col-sm-5 col-md-5" >

    <div class="form-check form-check-inline">
        <input class="form-check-input"  type="radio"  id="Legal" formControlName="Driver" value="Yes" >
        <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text14' | translate}}</label>
    </div>
    <div class="form-check form-check-inline">
        <input class="form-check-input"  type="radio"  id="Legal" formControlName="Driver" value="No" >
        <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text15' | translate}}</label>
    </div>     


    <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('Driver').invalid">
      ***required field***
    </div>
    
  </div>
</div>




<div class="form-row">
  <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
    <label>{{'Step7-Availability.TranslationSection.text16' | translate}}</label>

  </div>
  <div class="form-group  col-lg-5 col-sm-5 col-md-5" >

    <div class="form-check form-check-inline">
        <input class="form-check-input"  type="radio"  id="Legal" formControlName="Driver2" value="Yes" >
        <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text17' | translate}}</label>
    </div>
    <div class="form-check form-check-inline">
        <input class="form-check-input"  type="radio"  id="Legal" formControlName="Driver2" value="No" >
        <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text18' | translate}}</label>
    </div> 
    
    
    <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('Driver2').invalid">
      ***required field***
    </div>
  </div>
</div>



<div class="form-row">
  <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
    <label>{{'Step7-Availability.TranslationSection.text19' | translate}}</label>

  </div>
  <div class="form-group  col-lg-5 col-sm-5 col-md-5" >

    <div class="form-check form-check-inline">
        <input class="form-check-input"  type="radio"  id="Legal" formControlName="Driver3" value="Yes" >
        <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text20' | translate}}</label>
    </div>
    <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio"  id="Legal" formControlName="Driver3" value="No" >
        <label class="form-check-label" for="yes">{{'Step7-Availability.TranslationSection.text21' | translate}}</label>
    </div>     


    
    <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('Driver3').invalid">
      ***required field***
    </div>
  </div>
</div>

    </div>



  
</div>

    <br/>

        <button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>{{'Step7-Availability.TranslationSection.text22' | translate}}</button>
    &nbsp;
    <button type="submit"  class="btn btn-primary" >{{'Step7-Availability.TranslationSection.text23' | translate}} &nbsp;
      <i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>   


      <div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> {{'Step7-Availability.TranslationSection.text24' | translate}}</i>

    
  </form>

<!--</div>-->